import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../api';

// Users for filters/selects, from /api/users (not a hardcoded list).
export default function useUsers(loggedInUser) {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_BASE_URL}/api/users`, { params: { username: loggedInUser } })
      .then((res) => { if (!cancelled) setUsers((res.data || []).map((u) => u.username)); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [loggedInUser]);

  return users;
}
